<crm-deal-form
  *ngIf="(loading$ | async) === false"
  [deal]="deal"
  [canDelete]="(form$ | async)?.isEdit"
  [isModal]="true"
  [groups]="groups"
  [directions]="directions"
  [tasks]="tasks"
  [projects]="projects"
  (save)="saveDeal($event)"
  (delete)="deleteDeal()">
</crm-deal-form>

<crm-spinner *ngIf="loading$ | async"></crm-spinner>
